export default "__VITE_ASSET__DfJgM3KT__"